import styled from "styled-components";

import { TEXT_SECONDARY } from "../../colors";
import { Body } from "../../typography";

export const HelperText = styled(Body).attrs({
  as: "div"
})`
  color: ${TEXT_SECONDARY};
`;
